import styled from "@emotion/styled";
import { ThemeStyle } from "assets/scss/common/theme";


export const DetectedCityLayout = styled.div`
  height: 72px;
  width: 100%;
  margin-bottom: 16px;
  border-radius: 8px;
  background-color: ${props => props.backgroudColor};
`;

export const LocationLayout = styled.div`
  background: url(${props => props.backgroudURL}) no-repeat;
  background-size: contain;
  background-position-x: right;
  border-radius: 8px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 16px;
  ${props => props.errorFetchingGeoLocation ? "mix-blend-mode: luminosity" : ""};

  icon {
    height: 27px;
    width: auto;
  }
`;

export const AutoDetectButton = styled.button`
  border: none;
  cursor: pointer;
  background-color: ${({ theme }: ThemeStyle) => theme.transparent};
  text-align: left;
  align-items: center;
  img {
    margin-right: 8px;
  }
  .locate-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 54px;
  }
`;
